import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const preorderFragment = `
    on ${QueryType.skus} {
        preorder_date
    }
`;

export const preorderFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.skus]: preorderFragment
    };
};
